import { makeStyles, Tab, Tabs } from '@material-ui/core';
import { Collection, Linked } from '@type-r/models';
import * as React from 'react';
import { categories, CategoryTab } from './common';
import { CommunicationModel } from '../../../../api/communication';

export interface CommunicationsHeaderProps {
    $category : Linked<CategoryTab>
    communications : Collection<CommunicationModel>
}

export const CommunicationsHeader = ({ $category, communications } : CommunicationsHeaderProps ) =>{
    const classes = useStyles();

    // Calculate number of items in each category.
    const itemsInCategory : any = communications.groupBy( 'read', ( n : number = 0 ) => n + 1 );

    itemsInCategory.all = communications.models.length;
    itemsInCategory.unread = communications.filter(x => x.read ===false).length;
    itemsInCategory.read = communications.filter(x => x.read ===true).length;
    return (
        <div className={ classes.root }>
            <Tabs value={ $category.value } onChange={ (_, x ) => $category.set( x ) }>
                { categories
                    .map( category =>
                        category !== 'separator' ? (
                                <Tab
                                    value={ category }
                                    key={ category }
                                    classes={{
                                        root : classes.tab,
                                        selected : classes.selected
                                    }}

                                    disabled={ !itemsInCategory[ category ]}

                                    label={
                                        <CategoryTab
                                            key={ category }
                                            category={ category }
                                            count={ itemsInCategory[ category ] || 0 }
                                        />
                                    }
                                />
                        ):
                            <Tab
                                key="disabled"
                                value={ category }
                                disabled
                                classes={{
                                    root : classes.separator
                                }}

                                label={
                                    <span className={classes.separatorElement}/>
                                }
                            />
                    )
                }
            </Tabs>

        </div>
    )
}

const CategoryTab = ({ category, count }) => {
    const classes = useStyles();

    return (
        <div className={ classes.orderTab }>
            <div className={ classes.number }>{ count.toLocaleString() }</div>
            <div className={ classes.title }>{ category } </div>
        </div>
    )
}

const useStyles = makeStyles({
    root : {
        backgroundColor: '#052C4C',
        color: 'white',
        paddingBottom: 10
    },

    orderTab : {
        fontFamily: 'Montserrat',
        paddingBottom: 2,
        textAlign: 'left',
    },

    separator : {
        width: 35,
        minWidth: 20,
    },

    separatorElement : {
        borderLeft: 'solid',
        borderWidth: 1,
        borderColor: 'white',
        height: 41,
        marginTop: 7,
    },

    number : {
        fontSize: 28,
        fontWeight: 300
    },

    title : {
        fontSize: 12,
        fontWeight: 600,
        marginTop: -8,
        textTransform: 'uppercase'
    },

    tab: {
        minWidth: 80, // a number of your choice

        '&:hover': {
            color: '#FFF',
            opacity: 1,
        },

        '&:focus': {
            color: '#FFF',
            opacity: 1
        },

        '&$selected': {
            color: '#FFF',
            opacity: 1
        }
    },

    selected : {}
});
